/**
 * Trap system type definitions
 * Passive trapping mechanic: Set → Soak → Pull
 */

/**
 * Trap soak state — tracks what's currently happening with the player's trap
 */
export enum TrapStatus {
  EMPTY = 'empty',       // No trap set (or no trap owned)
  SOAKING = 'soaking',   // Trap is in the water, timer counting
  READY = 'ready',       // Soak complete, ready to pull
  COOLDOWN = 'cooldown', // Just pulled, brief cooldown before next set
}

/**
 * Persisted trap state on PlayerState
 */
export interface TrapState {
  // Current soak session
  status: TrapStatus;
  soakStartedAt: number | null;      // Timestamp when trap was set
  soakDurationMs: number;            // How long this trap takes to soak (from equipment)
  readyAt: number | null;            // Timestamp when soak completes
  cooldownEndsAt: number | null;     // Timestamp when cooldown expires

  // Bait (optional — enhances yield)
  selectedTrapBait: string | null;   // Equipment ID of selected trap bait

  // Lifetime stats
  totalTrapsSet: number;
  totalTrapsPulled: number;
  totalCreaturesCaught: number;
  totalTrapValueEarned: number;
}

/**
 * Trap balance configuration (added to BALANCE_CONFIG)
 */
export interface TrapBalanceConfig {
  TRAP_COOLDOWN_MS: number;          // Cooldown between pulls (30s)
  TRAP_BASE_YIELD_MIN: number;       // Min creatures without bait
  TRAP_BASE_YIELD_MAX: number;       // Max creatures without bait
  TRAP_BAIT_YIELD_BONUS: number;     // Extra creatures when baited (+1-2)
  TRAP_BAIT_QUALITY_BONUS: number;   // Quality bonus from using bait
}
